import axios from "axios";
import appConfig from "configs/app.config";
import { Environment, getEnvironment } from "utils/getEnvironment";

const axiosQuery =
  ({ baseUrl } = { baseUrl: "" }) =>
  async ({ url, method, data, params }, api, extraOptions) => {
    try {
      const result = await axios({
        url: baseUrl + url,
        method,
        data,
        params,
      });
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const authQuery = axiosQuery({
  baseUrl: getEnvironment(Environment.DEVELOPMENT)
    ? appConfig.apiStaging
    : appConfig.apiPrefix,
});
